import { bsc, bscTestnet } from "wagmi/chains";


export const contract = {
  97: {
    STAKE_ADDRESS: "0x960c9616d5bf8373f7b894e70d74a2c74f30a799",
    MULTICALL_ADDRESS: "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18"
  },
  56: {
    STAKE_ADDRESS: "0x614C1ba91A072016e97454e61dc2ef136BB848d6",
    MULTICALL_ADDRESS: "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116"
  }
}

export const DEFAULT_RPC = "https://data-seed-prebsc-2-s1.binance.org:8545/"
export const PROJECT_ID = "27b9720018bf7f8740936e6a6eb28604";
export const DEFAULT_CHAIN = 97;
export const EXPLOER = 'https://testnet.bscscan.com';
export const chains = [bscTestnet];
export const INIT_USER = 1500;
export const INIT_AMOUNT = 8000;
export const DECIMALS = 18;
export const SYMBOL = 'UDC';

export const TAX_WALLETS = {
  liquiditywallet : "0xAd5292D3D35F57CC0D7876cfD7B583DC99637b0d",
  buybackburn : "0x1969Ff10aAa911244574A0F30337FB0555bD8E3F",
  marketing : "0x0Fe5509CFF9256F9434ec7C14D0E3389dAC6ab93",
  dailybuyback : "0x0Fe5509CFF9256F9434ec7C14D0E3389dAC6ab93",
}







